import * as React from 'react';

export interface HamburgerProps {
    children: any;
    automationId?: string;
    disabled?: boolean;
}

export const HamburgerMenu = ({ children, automationId, disabled = false }: HamburgerProps) => {
    return (
        <div className="btn-group" role="group">
            <button
                disabled={disabled}
                data-automationid={automationId}
                type="button"
                className="btn btn-primary btn-xs dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <i className="fa fa-bars" aria-hidden="true" />
            </button>
            <ul className="dropdown-menu scrollable-menu pull-right" role="menu">
                {children}
            </ul>
        </div>
    );
}

